import { Routes } from '@angular/router';
import { AuthLayoutComponent } from '@components/layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from '@components/layout/main-layout/main-layout.component';
import { authGovbrGuard } from '@core/guards/auth-govbr.guard';
import { demandaAcaoGuard } from '@core/guards/demanda-acao.guard';
import { loginGuard } from '@core/guards/login.guard';
import { roleGuard } from '@core/guards/role.guard';
import { AccessDeniedComponent } from '@pages/access-denied/access-denied.component';
import { ControleUsuariosComponent } from '@pages/controle-usuarios/controle-usuarios.component';
import { AdicionarDemandaAnexosComponent } from '@pages/demandas/adicionar-demanda/adicionar-demanda-anexos/adicionar-demanda-anexos.component';
import { AdicionarDemandaFormComponent } from '@pages/demandas/adicionar-demanda/adicionar-demanda-form/adicionar-demanda-form.component';
import { AdicionarDemandaComponent } from '@pages/demandas/adicionar-demanda/adicionar-demanda.component';
import { MapaDemandasComponent } from '@pages/demandas/mapa-demandas/mapa-demandas.component';
import { TabelaDemandasComponent } from '@pages/demandas/tabela-demandas/tabela-demandas.component';
import { LoginConcessionariasComponent } from '@pages/login/login-concessionarias/login-concessionarias.component';
import { LoginComponent } from '@pages/login/login.component';
import { RedirectCallbackComponent } from '@pages/redirect-callback/redirect-callback.component';
import { SessionExpiredComponent } from '@pages/session-expired/session-expired.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'demandas',
        component: MapaDemandasComponent,
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'mapa' },
          { path: 'mapa', component: MapaDemandasComponent },
          { path: 'lista', component: TabelaDemandasComponent },
          { path: 'mapa-calor', component: MapaDemandasComponent },
        ],
      },
      {
        path: 'demandas/adicionar',
        component: AdicionarDemandaComponent,
        canActivate: [demandaAcaoGuard],
        children: [
          { path: 'descricao', component: AdicionarDemandaFormComponent },
          { path: 'anexos', component: AdicionarDemandaAnexosComponent },
        ],
      },
      {
        path: 'controle-usuarios',
        component: ControleUsuariosComponent,
        canActivate: [roleGuard],
        data: { roles: ['ADMIN'] },
      },
      {
        path: 'cadastro-tipo-representacao-govbr',
        component: MapaDemandasComponent,
        canActivate: [authGovbrGuard],
        data: {
          showCadastroTipoRepresentacao: true,
        },
      },
      { path: '', redirectTo: 'demandas', pathMatch: 'full' },
    ],
  },

  {
    path: 'auth',
    component: AuthLayoutComponent,
    canActivate: [loginGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'login' },
      { path: 'login', component: LoginComponent },
      {
        path: 'login-concessionarias',
        component: LoginConcessionariasComponent,
      },
      { path: 'redirect-callback', component: RedirectCallbackComponent },
      { path: 'access-denied', component: AccessDeniedComponent },
      { path: 'session-expired', component: SessionExpiredComponent },
    ],
  },

  { path: '**', redirectTo: '/' },
];
